// next
// import Image from "next/image";

// third party
import cx from "classnames";

// types
import { Practice } from "@/typedef/trial";

// styles
import styles from "../index.module.scss";

type LngLat = {
  latitude: number;
  longitude: number;
};

const getDistance = (from: LngLat, to: LngLat) => {
  const lat1 = from.latitude;
  const lon1 = from.longitude;
  const lat2 = to.latitude;
  const lon2 = to.longitude;

  const radLat1 = (Math.PI * lat1) / 180;
  const radLat2 = (Math.PI * lat2) / 180;
  const theta = lon1 - lon2;
  const radTheta = (Math.PI * theta) / 180;

  let dist =
    Math.sin(radLat1) * Math.sin(radLat2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);

  if (dist > 1) {
    dist = 1;
  }

  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;

  return Math.ceil(dist * 100) / 100;
};

export default function AddressOption({
  index,
  practice,
  selected,
  onSelect,
  geo,
}: {
  geo: { latitude: number; longitude: number } | null;
  index: number;
  practice: Practice;
  selected?: boolean;
  onSelect: (practice: Practice) => void;
}) {
  const distance = geo ? getDistance(geo, practice.address) : null;

  return (
    <div
      className={cx(styles.practice, "d-flex align-items-center justify-content-between", {
        [styles.selected]: selected,
      })}
      id={`marker-${practice.id}`}
      onClick={() => onSelect(practice)}
    >
      <div className={styles.info}>
        <p className="text-style-body1-bold">
          {index + 1}. {practice.name}
        </p>
        <p className="my-1 text-style-body1-regular">
          {[
            practice.address.addressOne,
            practice.address.city,
            `${practice.address.state} ${practice.address.zip}`,
          ].join(", ")}
        </p>
        <p className="text-style-body1-regular">
          {practice.phone}{" "}
          {distance && (
            <>
              <span>&bull;</span> {distance} miles
            </>
          )}
        </p>
      </div>
      {/* <div className={styles.image}>
        <Image src="/trial/placeholder" alt="" fill sizes="10vw" />
      </div> */}
    </div>
  );
}
